import React from 'react';
import "./MyFooter.css";

export const MyFooter = () => {
    return (
        <>
            <div className="whole-footer" style={{ backgroundImage: "linear-gradient(to right, rgba(255,0,0,0), rgba(255,0,0,1))" }}>
                <footer className="text-center text-lg-start text-muted" style={{ boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)' }}>
                    <section>
                        <div className="container text-center text-md-start">
                            <div className="row mt-3">
                                <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4 mt-4">
                                    <h6 className="text-uppercase fw-bold mb-4">
                                        <i className="fas fa-gem me-3"></i>Lone Wolf Writes
                                    </h6>
                                    <p>
                                        No one appreciates the 'BEST' in you,<br />
                                        But everyone fears the 'BEAST' in you.
                                    </p>
                                    <a href="/"><picture><img src="/lone-wolf-writes-logo.jpg" alt=" logo | Lone Wolf writes " style={{ width: "250px" }} /></picture></a>
                                </div>
                                <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4 mt-4">
                                    <h6 className="text-uppercase fw-bold mb-4">
                                        Read
                                    </h6>
                                    <p>
                                        <a href="/blogs" className="text-reset" style={{ textDecoration: 'none' }}>Blogs</a>
                                    </p>
                                    <p>
                                        <a href="/quotes" className="text-reset" style={{ textDecoration: 'none' }}>Quotes</a>
                                    </p>
                                    <p>
                                        <a href="/poems-eng" className="text-reset" style={{ textDecoration: 'none' }}>Poems</a>
                                    </p>
                                    <p>
                                        <a href="/poems-mar" className="text-reset" style={{ textDecoration: 'none' }}>कविता</a>
                                    </p>
                                </div>
                                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4 m-4">
                                    <h6 className="text-uppercase fw-bold mb-4">
                                        Useful links
                                    </h6>
                                    <p>
                                        <a href="/" className="text-reset" style={{ textDecoration: 'none' }}>Lone Wolf Writes</a>
                                    </p>
                                    <p>
                                        <a href="/privacy-policy" className="text-reset" style={{ textDecoration: 'none' }}>Privacy Policy</a>
                                    </p>
                                    <p>
                                        <a href="/about" className="text-reset" style={{ textDecoration: 'none' }}>About</a>
                                    </p>
                                    <p>
                                        <a href="/contact" className="text-reset" style={{ textDecoration: 'none' }}>Contact Us</a>
                                    </p>
                                </div>
                                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4 mt-4">
                                    <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                                    <div className="social">
                                        <div className="row mb-2"> 
                                            <div className="col md-2">
                                            <i className="fas fa-envelope me-3"></i>
                                                <picture><a href="https://www.facebook.com/lonewolfwrites9019"><img src="/media/socialMediaLogos/facebook.png" alt="FB" style={{ height: "30px"}} /></a></picture>
                                            </div>
                                            <div className="col md-2">
                                                <picture><a href="https://www.instagram.com/lonewolfwrites_"><img src="/media/socialMediaLogos/instagram.png" alt="Insta" style={{ height: "30px"}} /></a></picture>
                                            </div>
                                            <div className="col md-2">
                                                <picture><a href="https://x.com/lonewolfwrites_"><img src="/media/socialMediaLogos/x.png" alt="x" style={{ height: "30px"}} /></a></picture>
                                            </div>
                                            <div className="col md-2">
                                                <picture><a href="https://in.pinterest.com/lonewolfwrites_"><img src="/media/socialMediaLogos/pintrest.png" alt="pintrest" style={{ height: "30px"}} /></a></picture>
                                            </div>
                                            <div className="col md-2">
                                                <picture><a href="https://www.reddit.com/user/lonewolfwrites_"><img src="/media/socialMediaLogos/reddit.png" alt="reddit" style={{ height: "30px"}} /></a></picture>
                                            </div>
                                        </div>
                                    </div>
                                    <p>
                                        <i className="fas fa-envelope me-3"></i>
                                        <a href="mailto:pranav.gaikwad@lonewolfwrites.com" className="email-link text-reset" style={{ textDecoration: "none" }}>pranav.gaikwad@lonewolfwrites.com</a></p>
                                    <p><i className="fas fa-phone me-3"></i> + 91 9503 66 1843</p>
                                    <p><i className="fas fa-print me-3"></i> + 91 7276 33 1843</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <hr />
                    <div className="text-center p-4">
                        © 2023 Copyright:
                        <a className="text-reset fw-bold" href="/" style={{ textDecoration: 'none' }}>lonewolfwrites.com</a>
                    </div>
                </footer>
            </div>
        </>
    )
}
